import React from 'react'
import { Boton } from './buttonStyle';
import './button.scss'

const Button = ({id_boton, clases, funcion, nombre, tipo, disabled}) => {
    return (
        <Boton id={id_boton} className={clases} onClick={funcion} type={tipo}
        disabled={disabled}>{nombre} </Boton>
    )
}

export default Button
